import { requestJson } from "../core/http.js";

export class DevAccess {
  constructor({ supabaseUrl, supabaseAnonKey, apiBase }, clientFactory) {
    this.config = { supabaseUrl, supabaseAnonKey, apiBase };
    this.clientFactory = clientFactory;
    this.client = null;
  }

  get configured() {
    return Boolean(this.config.supabaseUrl && this.config.supabaseAnonKey && this.config.apiBase);
  }

  async #supabase() {
    if (!this.client) {
      const factory = this.clientFactory || (await import("@supabase/supabase-js")).createClient;
      this.client = factory(this.config.supabaseUrl, this.config.supabaseAnonKey, {
        auth: { persistSession: true, detectSessionInUrl: true, flowType: "pkce" }
      });
    }
    return this.client;
  }

  async sendMagicLink(email) {
    const supabase = await this.#supabase();
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: `${location.origin}/#/dev`, shouldCreateUser: true }
    });
    if (error) throw error;
  }

  async session() {
    if (!this.configured) return null;
    const supabase = await this.#supabase();
    const { data } = await supabase.auth.getSession();
    return data.session;
  }

  async buildInfo() {
    const session = await this.session();
    if (!session) return null;
    return requestJson(`${this.config.apiBase}/api/dev/build`, {
      headers: { Authorization: `Bearer ${session.access_token}` },
      timeoutMs: 15000
    });
  }

  async signOut() {
    const supabase = await this.#supabase();
    await supabase.auth.signOut();
  }
}
